import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgMailruMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16Z"
      fill="url(#MailruMail_svg__a)"
    />
    <path
      d="M19.309 16A3.312 3.312 0 0 1 16 19.309 3.312 3.312 0 0 1 12.691 16 3.312 3.312 0 0 1 16 12.691 3.312 3.312 0 0 1 19.309 16ZM16 5C9.934 5 5 9.934 5 16s4.934 11 11 11c2.222 0 4.365-.662 6.196-1.913l.032-.022-1.482-1.723-.025.016A8.703 8.703 0 0 1 16 24.745c-4.822 0-8.745-3.923-8.745-8.745 0-4.822 3.923-8.745 8.745-8.745 4.822 0 8.745 3.923 8.745 8.745 0 .625-.07 1.257-.206 1.88-.276 1.135-1.072 1.482-1.668 1.437-.6-.05-1.303-.477-1.307-1.523V16A5.57 5.57 0 0 0 16 10.436 5.57 5.57 0 0 0 10.436 16 5.57 5.57 0 0 0 16 21.564c1.49 0 2.888-.583 3.942-1.642a3.575 3.575 0 0 0 3.044 1.654c.8 0 1.593-.268 2.233-.753.659-.5 1.152-1.224 1.423-2.094.044-.14.124-.462.124-.465l.002-.011c.16-.698.232-1.393.232-2.253 0-6.066-4.934-11-11-11Z"
      fill="#FF9E00"
    />
    <defs>
      <linearGradient
        id="MailruMail_svg__a"
        x1={32}
        y1={32}
        x2={0}
        y2={0}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#005FF9" />
        <stop offset={1} stopColor="#4583FE" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgMailruMail);
export default Memo;
